import { render, staticRenderFns } from "./NewPortfolioModal.vue?vue&type=template&id=59041e57&scoped=true&"
import script from "./NewPortfolioModal.vue?vue&type=script&lang=ts&"
export * from "./NewPortfolioModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewPortfolioModal.vue?vue&type=style&index=0&id=59041e57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59041e57",
  null
  
)

export default component.exports